import { render, staticRenderFns } from "./SingleChoiceV1.vue?vue&type=template&id=63d3531e&"
import script from "./SingleChoiceV1.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports